import AbstractPathBrowserStore from "csi/data/AbstractPathBrowserStore";
import declare from "dojo/_base/declare";
import ExtendedPath from "csi/core/ExtendedPath";
import xml from "csi/xml";
import DataPackageTemplateSheetFilterController from "./DataPackageTemplateSheetFilterController";

const DataPackageTemplateNestedSheetFilterController = declare(DataPackageTemplateSheetFilterController, {

	/**
	 * @override
	 * C8-51144: Add an extended path to NestedSheetParentType attributes
	 */
	getAttributesStore(): AbstractPathBrowserStore {
		const store = this.inherited(arguments) as unknown as AbstractPathBrowserStore;
		const startType = this._getStartType();
		const targetType = xml.enumGetText(this.getNode().NestedSheetParentType);

		const path = new ExtendedPath(startType);
		path.addRelationStep(xml.ATTR_PARENT, targetType);
		store.addTopLevelItemsFromPath(path);

		return store;
	},
});

export = DataPackageTemplateNestedSheetFilterController;
